<ng-container>
  <app-feature-list-container [title]="'+INSTALLATIONS.INSTALLATION.ACCESS_LIST.TITLE' | translate">
    <ng-container
      *ngIf="(installationDetailsStore.ownershipType$ | async) === ownershipType.ResidentialEndUser"
    >
      <ng-container
        *ngrxLet="{
          endUserList: installationDetailsStore.accessListEndUserAndFamilyMembersList$,
          maintainersList: installationDetailsStore.accessListMaintainersList$
        } as accessListData"
      >
        <section *ngIf="accessListData.endUserList?.length" class="mb-[24px]">
          <h3>{{ 'COMMON.USER_ROLES.END_USER' | translate }}</h3>
          <div *ngFor="let user of accessListData.endUserList" class="p-2 pl-[38px]">
            <div class="flex flex-row xs:flex-col">
              <a
                target="_blank"
                gtm="onGoToPage"
                gtmAction="User details"
                gtmCategory="gatewayAccessList"
                [routerLink]="['/users', user?.id]"
              >
                {{ user.firstName }} {{ user.familyName }}</a
              >
              <span>({{ user.email }})</span>
            </div>
          </div>
        </section>

        <section *ngIf="accessListData?.maintainersList.length" class="mb-[24px]">
          <h3>{{ 'COMMON.USER_ROLES.MAINTAINER' | translate }}</h3>
          <ng-container *ngFor="let maintainer of accessListData.maintainersList">
            <mat-accordion [togglePosition]="'before'">
              <mat-expansion-panel
                class="access-list-company"
                (opened)="getEmployeesList(maintainer.customerNumber, maintainer.loaded)"
                [expanded]="maintainer?.employees?.length > 0"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ maintainer.companyName }}
                  </mat-panel-title>
                  <ng-container *ngIf="maintainer.loading">
                    <mat-spinner class="spinner"></mat-spinner>
                  </ng-container>
                </mat-expansion-panel-header>
                <ng-container *ngIf="!maintainer.loading">
                  <div *ngFor="let employee of maintainer?.employees" class="p-2 ml-[28px]">
                    <div class="flex flex-row xs:flex-col">
                      <a
                        target="_blank"
                        gtm="onGoToPage"
                        gtmAction="User details"
                        gtmCategory="gatewayAccessList"
                        [routerLink]="['/users', employee.iamId]"
                        >{{ employee.firstName }} {{ employee.familyName }}</a
                      >
                      <span>({{ employee.email }})</span>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!maintainer.loading && maintainer?.employees?.length === 0">
                  <div class="error-message ml-[28px]">
                    {{ '+INSTALLATIONS.INSTALLATION.ACCESS_LIST.NO_DATA' | translate }}
                  </div>
                </ng-container>
                <ng-container *ngIf="maintainer.error">
                  <div class="error-message ml-[28px]">
                    {{ '+INSTALLATIONS.INSTALLATION.ACCESS_LIST.ERROR' | translate }}
                  </div>
                </ng-container>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>
        </section>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="installationDetailsStore.accessListForCommercial$ | async as commercialList"
    >
      <div class="flex flex-col gap-[20px]">
        <ng-container>
          <mat-expansion-panel
            class="access-list-company"
            *ngIf="commercialList.companyAccounts.length > 0"
          >
            <mat-expansion-panel-header>
              <div class="list-item flex flex-row xs:flex-col">
                {{ '+INSTALLATIONS.INSTALLATION.ACCESS_LIST.COMPANY_IDENTIFY' | translate }}:
                {{ commercialList.companyOwnerNumber }} ({{ commercialList.companyName }})
              </div>
            </mat-expansion-panel-header>
            <div class="px-[8px]" *ngFor="let companyAccount of commercialList.companyAccounts">
              <a
                target="_blank"
                gtm="onGoToPage"
                gtmAction="User details"
                gtmCategory="gatewayAccessList"
                [routerLink]="['/users', companyAccount?.viAccount]"
              >
                {{ companyAccount.firstName }} {{ companyAccount.lastName }} ({{
                  companyAccount.email
                }})
              </a>
            </div>
          </mat-expansion-panel>
          <ng-container *ngFor="let partner of commercialList.partners">
            <mat-expansion-panel class="access-list-company" *ngIf="partner.accounts.length > 0">
              <mat-expansion-panel-header>
                <div class="list-item flex flex-row xs:flex-col">
                  {{ '+INSTALLATIONS.INSTALLATION.ACCESS_LIST.PARTNER_IDENTIFY' | translate }}:
                  {{ partner.customerNumber }} ({{ partner.companyName }})
                </div>
              </mat-expansion-panel-header>
              <div class="px-[8px]" *ngFor="let partnerAccount of partner.accounts">
                <a
                  target="_blank"
                  gtm="onGoToPage"
                  gtmAction="User details"
                  gtmCategory="gatewayAccessList"
                  [routerLink]="['/users', partnerAccount?.viAccount]"
                >
                  {{ partnerAccount.firstName }} {{ partnerAccount.lastName }} ({{
                    partnerAccount.email
                  }})
                </a>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </ng-container>
      </div>
      <ng-container>
        <div
          *ngIf="
            (installationDetailsStore.isAccountsInAllCompanyEmpty$ | async) &&
            (installationDetailsStore.accessListUserList$ | async).length === 0 &&
            !(installationDetailsStore.getAccessListUserByCustomer$ | async)
          "
          class="flex flex-col gap-[20px]"
        >
          <app-banner size="thin" type="warning">
            {{ '+INSTALLATIONS.INSTALLATION.ACCESS_LIST.NO_DATA' | translate }}
          </app-banner>
        </div>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="
        installationDetailsStore.getAccessListUserByCustomer$ | async as accessListUserByCustomer
      "
    >
      <div class="flex flex-col gap-[20px]">
        <ng-container *ngIf="accessListUserByCustomer.buildingManager as buildingManager">
          <app-access-list-user [userData]="buildingManager"></app-access-list-user>
        </ng-container>
        <ng-container *ngIf="accessListUserByCustomer.serviceContractor as serviceContractor">
          <app-access-list-user [userData]="serviceContractor"></app-access-list-user>
        </ng-container>
        <ng-container *ngIf="accessListUserByCustomer.operator as operator">
          <app-access-list-user [userData]="operator"></app-access-list-user>
        </ng-container>
      </div>
      <ng-container>
        <div
          *ngIf="
            (installationDetailsStore.isAccountsInAllCompanyEmpty$ | async) &&
            (installationDetailsStore.accessListUserList$ | async).length === 0 &&
            (installationDetailsStore.accessListMaintainersList$ | async).length === 0
          "
          class="flex flex-col gap-[20px]"
        >
          <app-banner size="thin" type="warning">
            {{ '+INSTALLATIONS.INSTALLATION.ACCESS_LIST.NO_DATA' | translate }}
          </app-banner>
        </div>
      </ng-container>
    </ng-container>
  </app-feature-list-container>
</ng-container>
